export const URL_BASE_AUTH = 'https://quaint-lake-42xupyydncaq.vapor-farm-e1.com/api/v1'
// export const URL_BASE_CORE = 'https://back-sferafarma.enpreproduccion.com/api/v1'
export const URL_BASE_CORE = 'https://back.sferafarma.cloud/api/v1'
